'use strict';
import {buildColumnDefs} from "../../../../chain/ChainColumnDefs";

{
    var app = angular.module('tf.strategy.mobile', [])

        .controller('strategyAsideCtrl', ['$scope', '$uibModalInstance', 'strategies', 'activeStrategy', 'strategyTabs', '$localStorage', function strategyAsideController($scope, $uibModalInstance, strategies, activeStrategy, strategyTabs, $localStorage){

            $scope.strategies = strategies;

            $scope.activeStrategy = activeStrategy;

            $scope.strategyTabs = strategyTabs;

            $scope.cancel = function () {
                $uibModalInstance.dismiss('cancel');
            };

            $scope.setActiveStrategy = function(strategy) {
                $localStorage['active_strategy'] = strategy.id;
                $scope.strategyTabs.activeIndex = 'Strategy' + strategy.id;

                $uibModalInstance.dismiss('cancel');

            };


        }])

        .controller('payoffMobileGridCtrl', ['$scope', '$uibModalInstance', 'maxLoss', 'maxGain', 'strategyMovements' , function payoffMobileController($scope, $uibModalInstance, maxLoss, maxGain, strategyMovements){

            $scope.strategyMovements = strategyMovements;


            $scope.maxLoss = maxLoss;
            $scope.maxGain = maxGain;

            $scope.cancel = function () {
                $uibModalInstance.dismiss('cancel');
            };



        }])

        .controller('payoffMobileDiagramCtrl', ['$scope', '$uibModalInstance', 'payoffInputService', 'payoffDataService', 'reloadStrategy' , function payoffMobileController($scope, $uibModalInstance, payoffInputService, payoffDataService, reloadStrategy){

            $scope.reloadStrategy = reloadStrategy;

            // TODO these are used to share state between the controllers as this controller isn't a component
            $scope.payoffInputService = payoffInputService;
            $scope.payoffDataService = payoffDataService;

            $scope.timeSeries = {
                value: 3,
                options: {
                    floor: 2,
                    ceil: 8,
                    onEnd: function(id) {
                        $scope.reloadStrategy();
                    }
                }
            };

            $scope.pricePoints = {
                value: 5,
                options: {
                    floor: 5,
                    ceil: 35,
                    onEnd: function(id) {
                        $scope.reloadStrategy();
                    }
                }
            };

            $scope.payoffDataOptions = {
                chart: {
                    type: 'lineChart',
                    height: 457,
                    margin: {
                        top: 20,
                        right: 20,
                        bottom: 20,
                        left: 55
                    },
                    x: function (d) {
                        return d.x;
                    },
                    y: function (d) {
                        return d.y;
                    },
                    useInteractiveGuideline: true,
                    interactiveLayer: {
                        tooltip: {
                            // This is broken but looks better than the other options
                            gravity: 'center',
                            headerFormatter: function (d) {
                                var steps = ($scope.payoffDataService.priceSteps.length - 1) / 2;

                                var index = d + steps;
                                if ($scope.points) {
                                    return "Price " + d3.format(',.01f')($scope.payoffDataService.priceSteps[index]);
                                } else {
                                    return "Price " + d3.format(',.03f')($scope.payoffDataService.priceSteps[index]);
                                }
                            }
                        }
                    },
                    dispatch: {},
                    xAxis: {
                        axisLabel: 'Price Change',
                        tickFormat: function (d) {
                            var steps = ($scope.payoffDataService.priceSteps.length - 1) / 2;

                            var index = d + steps;
                            if ($scope.payoffDataService.points) {
                                return d3.format(',.01f')($scope.payoffDataService.priceSteps[index]);
                            } else {
                                return d3.format(',.03f')($scope.payoffDataService.priceSteps[index]);
                            }
                        }

                    },

                    yAxis: {
                        axisLabel: 'Payoff ($)',
                        tickFormat: function (d) {
                            return d3.format(',f')(d);
                        },
                        axisLabelDistance: 0
                    }
                }
            };

            $scope.cancel = function () {
                $uibModalInstance.dismiss('cancel');
            };



        }])

        .controller('payoffChartCtrl', ['$scope', '$uibModalInstance', '$timeout', 'symbol', '$http', function payoffMobileController($scope, $uibModalInstance, $timeout, symbol, $http){

            $scope.symbol = symbol;
            $scope.chart = {
                range : '30d',
                chartVolatilityData : null,
                chartPriceData : null
            };

            $scope.optionsPrice = {
                chart: {
                    type: 'candlestickBarChart',
                    height: 300,
                    margin : {
                        top: 20,
                        right: 20,
                        bottom: 20,
                        left: 60
                    },
                    x: function(d){ return d['date']; },
                    y: function(d){ return d['close']; },
                    duration: 100,

                    xAxis: {
                        axisLabel: 'Dates',
                        tickFormat: function(d) {
                            return d3.time.format('%x')(new Date(d));
                        },
                        showMaxMin: false
                    },

                    yAxis: {
                        axisLabel: 'Stock Price',
                        tickFormat: function(d){
                            return '$' + d3.format(',.3f')(d);
                        },
                        showMaxMin: false
                    },
                    zoom: {
                        enabled: true,
                        scaleExtent: [1, 10],
                        useFixedDomain: false,
                        useNiceScale: false,
                        horizontalOff: false,
                        verticalOff: true,
                        unzoomEventType: 'dblclick.zoom'
                    }
                }
            };

            $scope.optionsPricePoints = {
                chart: {
                    type: 'candlestickBarChart',
                    height: 200,
                    width: 400,
                    margin : {
                        top: 10,
                        right: 10,
                        bottom: 20,
                        left: 60
                    },
                    x: function(d){ return d['date']; },
                    y: function(d){ return d['close']; },
                    duration: 100,

                    xAxis: {
                        axisLabel: 'Dates',
                        tickFormat: function(d) {
                            return d3.time.format('%x')(new Date(d));
                        },
                        showMaxMin: false
                    },

                    yAxis: {
                        axisLabel: 'Index',
                        tickFormat: function(d){
                            return d3.format(',.1f')(d);
                        },
                        showMaxMin: false
                    },
                    zoom: {
                        enabled: true,
                        scaleExtent: [1, 10],
                        useFixedDomain: false,
                        useNiceScale: false,
                        horizontalOff: false,
                        verticalOff: true,
                        unzoomEventType: 'dblclick.zoom'
                    }
                }
            };

            $scope.loadChartData = function() {
                return $http.get('/tradefloor/api/prices/chart/' + $scope.symbol.code + '?r=' + $scope.chart.range).then(function (response) {
                    Papa.parse(response.data, {
                        download: false,
                        complete: function (results) {
                            results.data.shift(); // Remove header

                            $scope.chart.chartPriceData = [{
                                values: results.data.filter(function (row) {
                                    return row[0];

                                })
                                    .map(function (row) {
                                        return {
                                            date: new Date(row[0]),
                                            open: parseFloat(row[1]),
                                            high: parseFloat(row[2]),
                                            low: parseFloat(row[3]),
                                            close: parseFloat(row[4])
                                        }
                                    })
                            }];

                            $scope.chart.chartVolatilityData = [{
                                key: 'Volatility', values: results.data.filter(function (row) {
                                    return row[0];

                                })
                                    .map(function (row) {
                                        return {
                                            date: new Date(row[0]),
                                            IV30: parseFloat(row[5]) * 100.0
                                        }
                                    })
                            }];

                        }
                    });
                });
            };

            $scope.loadChartData();

            $scope.cancel = function () {
                $uibModalInstance.dismiss('cancel');
            };


        }])

        .controller('chainMobileCtrl', ['$scope', '$uibModalInstance', '$timeout', 'chainService', 'optionPriceService', 'uiGridConstants', 'gridUtil', '$http', 'underlying', 'userConfig', 'spreadService', 'openInterestService', 'priceStrategyService',
            function chainMobileController($scope, $uibModalInstance, $timeout, chainService, optionPriceService, uiGridConstants, gridUtil, $http, underlying, userConfig, spreadService, openInterestService, priceStrategyService){

            $scope.underlying = underlying;
            $scope.priceStrategy = priceStrategyService.forCode(underlying);

            $scope.optionChain = {
                activeIndex : 'Call'
            };

            $scope.optionChainInput = {
                search : null,
                type : "call"
            };

            $scope.getChain = function(underlying) {
                return chainService(underlying)
                    .then(function (chain){
                        $scope.chain = chain;
                        $scope.updateSeries($scope.chain.series[0]);
                        $scope.loadChain($scope.chain);
                    }).then(function() {
                        return $http.get('/tradefloor/api/stockscreener?underlying=' + underlying).then(function(response) {
                            response.data.forEach(function (s) {
                                if (s.underlying == underlying) {
                                    $scope.stock = s;
                                }
                            });

                        });
                    });
            };

            $scope.getScrollPoint = function(put, options) {
                var scrollPoint = Math.floor(options.length / 2);
                if (put) {
                    while (options[scrollPoint].entity.put.itm && options[scrollPoint + 1].entity.put.itm || !options[scrollPoint].entity.put.itm && !options[scrollPoint + 1].entity.put.itm) {
                        if (!options[scrollPoint].entity.put.itm) {
                            scrollPoint++;
                        } else {
                            scrollPoint--;
                        }
                    }
                } else {
                    while (!options[scrollPoint - 1].entity.call.itm && !options[scrollPoint].entity.call.itm || options[scrollPoint - 1].entity.call.itm && options[scrollPoint].entity.call.itm) {
                        if (!options[scrollPoint].entity.call.itm) {
                            scrollPoint--;
                        } else {
                            scrollPoint++;
                        }
                    }
                }
                return scrollPoint;
            };

            $scope.gridOptions = {
                flatEntityAccess : false,
                enableVerticalScrollbar : uiGridConstants.scrollbars.ALWAYS,
                enableHorizontalScrollbar : uiGridConstants.scrollbars.NEVER,
                enableSorting: false,
                enableColumnMenus : false,
                onRegisterApi: function(gridApi){
                    $scope.callGridApi = gridApi;
                    gridUtil.disableAnimations(gridApi.grid.element);
                    gridApi.core.on.rowsRendered($scope, function() {
                        $timeout(function() {
                            if (!$scope.callGridApi.grid.rows.length) {
                                return;
                            }
                            var scrollPoint = $scope.getScrollPoint(false, $scope.callGridApi.grid.rows);
                            $scope.callGridApi.grid.scrollTo($scope.callGridApi.grid.rows[scrollPoint].entity, undefined);
                        },0);
                    });
                },

                excessRows : 25,
                minRowsToShow : 12,
                columnDefs : buildColumnDefs(userConfig),
                data : []
            };

            $scope.doubleSelectInstrument = function(instrument) {
                if (instrument != null && instrument.code != null) {
                    $uibModalInstance.close(instrument.code);
                }
            };

            $scope.selectUnderlying = () => {
                const code = scope.chain.code.toUpperCase();
                $uibModalInstance.close(code);
            };

            $scope.updateSeries = function(series) {
                $scope.currentSeries = series;
                optionPriceService($scope.chain.code, series.expiry).then(function(prices) {
                    $scope.currentPrice = prices;
                    $scope.mergeData().then(() => $scope.gridOptions.data = $scope.optionsChainData);
                    //$scope.gridOptionsPut.data = $scope.optionsChainData;
                });
            };

            $scope.mergeData = function() {
                var series = $scope.currentSeries;
                var prices = $scope.currentPrice;
                // var oi = $scope.openInterest;

                return openInterestService(underlying).then(oi => {

                    return spreadService($scope.chain.code, series.expiry).then((spreads) => {

                        $scope.optionsChainData = series.ladder.map(function (rung) {
                            var put = null;
                            if (rung.put) {
                                put = {
                                    option: rung.put,
                                    oi: oi.interest[rung.put.code] || 0,
                                    spread: spreads.spread[rung.put.code],
                                    price: prices.options[rung.put.code],
                                    itm: prices.price <= rung.level
                                };
                            }

                            var call = null;
                            if (rung.call) {
                                call = {
                                    option: rung.call,
                                    oi: oi.interest[rung.call.code] || 0,
                                    spread: spreads.spread[rung.call.code],
                                    price: prices.options[rung.call.code],
                                    itm: prices.price >= rung.level
                                };
                            }
                            return {
                                special: false,
                                level: rung.level,
                                put: put,
                                call: call
                            };
                        });
                    });
                });
            };

            $scope.loadChain = function(chain) {
                $scope.years = [];

                var tmpYear = {
                    year : 0,
                    series : []
                };
                for (var i = 0; i < chain.series.length; i++) {
                    var series = chain.series[i];

                    if (series.expiry.getFullYear() != tmpYear.year) {
                        tmpYear = {
                            year: series.expiry.getFullYear(),
                            series: [],
                            firstSeries : series,
                            defaultSeries : series,
                            firstQuarterSeries : null

                        };
                        $scope.years.push(tmpYear);
                    }

                    // XJO usually uses a quarterly expiry
                    if (chain.code == 'XJO' && tmpYear.firstQuarterSeries == null) {
                        if (((series.expiry.getMonth() + 1) % 3) == 0) {
                            tmpYear.firstQuarterSeries = series;
                        }
                    }

                    if (chain.asAt.getTime() == tmpYear.defaultSeries.expiry.getTime() && tmpYear.defaultSeries != series) {
                        tmpYear.defaultSeries = series;
                    }

                    // TODO try not to mangle the data that was passed in
                    series.year = tmpYear;
                    tmpYear.series.push(series);
                }
            };

            $scope.onSelectYear = function(year) {
                if (year.defaultSeries != $scope.currentSeries) {
                    $scope.updateSeries(year.defaultSeries);
                }
            };

            $scope.onSelectSeries = function(series) {
                // TODO need to use the input filter price too if we have it
                if (series != $scope.currentSeries) {
                    $scope.updateSeries(series);
                }
            };

            $scope.cancel = function () {
                $uibModalInstance.dismiss('cancel');
            };

            $scope.getChain(underlying);
        }]);
}
